import { type Components, type Theme } from '@mui/material/styles';

import getStyleQuery from '../../../utils/tools/getStyleQuery';

// ----------------------------------------------------------------------

export function stepper(theme: Theme): Components<Theme> {
    return {
        MuiStepConnector: {
            styleOverrides: {
                line: {
                    [getStyleQuery()]: {
                        borderColor: theme.palette.divider,
                    },
                },
            },
        },
    };
}
